import { Injectable } from '@angular/core';
import { Entrepreneur } from '../../../../shared/models/enums/entrepreneur.enum';
import { EmploymentAssetDto } from './employment-asset.dto';
import { EmploymentBarrierDto } from './employment-barrier.dto';
import { EmploymentQualificationDto } from './employment-qualification.dto';
import { EmploymentTransportModeDto } from './employment-transport.dto';

@Injectable()
export class BeneficiaryEmploymentDto {
  public readonly id: number;
  public readonly accreditationSIAE: boolean;
  public readonly accreditationSIAEDate: Date;
  public readonly rqth: boolean;
  public readonly expiryRqthDate: Date;
  public readonly entrepreneur: Entrepreneur;
  public readonly beginDateEntrepreneurship: Date;
  public readonly endDateEntrepreneurship: Date;
  public readonly sectorId: number;
  public readonly degreeId: number;
  public readonly trainingAreaIds: number[] = [];
  public readonly studyAbroad: boolean;
  public readonly wantedJobTypeId: number;
  public readonly barriers: EmploymentBarrierDto[] = [];
  public readonly assets: EmploymentAssetDto[] = [];
  public readonly qualificationTypes: EmploymentQualificationDto[] = [];
  public readonly transportModes: EmploymentTransportModeDto[] = [];
  public readonly jobIds: number[] = [];

  constructor(values?: {
    id: number;
    accreditationSIAE: boolean;
    accreditationSIAEDate: Date;
    rqth: boolean;
    expiryRqthDate: Date;
    entrepreneur: Entrepreneur;
    beginDateEntrepreneurship: Date;
    endDateEntrepreneurship: Date;
    sectorId: number;
    degreeId: number;
    trainingAreaIds: number[];
    studyAbroad: boolean;
    wantedJobTypeId: number;
    barriers: EmploymentBarrierDto[];
    assets: EmploymentAssetDto[];
    qualificationTypes: EmploymentQualificationDto[];
    transportModes: EmploymentTransportModeDto[];
    jobIds: number[];
  }) {
    if (values) {
      this.id = values.id;
      this.accreditationSIAE = values.accreditationSIAE;
      this.accreditationSIAEDate = values.accreditationSIAEDate;
      this.rqth = values.rqth;
      this.expiryRqthDate = values.expiryRqthDate;
      this.entrepreneur = values.entrepreneur;
      this.beginDateEntrepreneurship = values.beginDateEntrepreneurship;
      this.endDateEntrepreneurship = values.endDateEntrepreneurship;
      this.sectorId = values.sectorId;
      this.degreeId = values.degreeId;
      this.trainingAreaIds = values.trainingAreaIds;
      this.studyAbroad = values.studyAbroad;
      this.wantedJobTypeId = values.wantedJobTypeId;
      this.barriers = values.barriers;
      this.assets = values.assets;
      this.qualificationTypes = values.qualificationTypes;
      this.transportModes = values.transportModes;
      this.jobIds = values.jobIds;
    }
  }

  public static fromJson(json: any): BeneficiaryEmploymentDto {
    return new BeneficiaryEmploymentDto({
      id: json.id,
      accreditationSIAE: json.accreditationSIAE,
      accreditationSIAEDate: json.accreditationSIAEDate ? new Date(json.accreditationSIAEDate) : undefined,
      rqth: json.rqth,
      expiryRqthDate: json.expiryRqthDate ? new Date(json.expiryRqthDate) : undefined,
      entrepreneur: json.entrepreneur,
      beginDateEntrepreneurship: json.beginDateEntrepreneurship ? new Date(json.beginDateEntrepreneurship) : undefined,
      endDateEntrepreneurship: json.endDateEntrepreneurship ? new Date(json.endDateEntrepreneurship) : undefined,
      sectorId: json.sectorId,
      degreeId: json.degreeId,
      trainingAreaIds: json.trainingAreaIds || [],
      studyAbroad: json.studyAbroad,
      wantedJobTypeId: json.wantedJobTypeId,
      barriers: (json.barriers || []).map(EmploymentBarrierDto.fromJson),
      assets: (json.assets || []).map(EmploymentAssetDto.fromJson),
      qualificationTypes: (json.qualificationTypes || []).map(EmploymentQualificationDto.fromJson),
      transportModes: (json.transportModes || []).map(EmploymentTransportModeDto.fromJson),
      jobIds: json.jobIds || [],
    });
  }
}
